import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ClipboardList, MessageSquare, FileText } from 'lucide-react';
import { UserSurveyDashboard } from '@/components/surveys/UserSurveyDashboard';
import { FeedbackCenter } from '@/components/surveys/FeedbackCenter';
import { SurveyTaker } from '@/components/surveys/SurveyTaker';

interface Survey {
  id: string;
  title: string;
  description: string;
  survey_type: string;
  course_id?: string;
  course_title?: string;
  created_at: string;
  questions: any[];
}

export default function Surveys() {
  const [activeTab, setActiveTab] = useState('surveys');
  const [currentSurvey, setCurrentSurvey] = useState<Survey | null>(null);

  const handleTakeSurvey = (survey: Survey) => {
    setCurrentSurvey(survey);
    setActiveTab('take-survey');
  };

  const handleCompleteSurvey = () => {
    setCurrentSurvey(null);
    setActiveTab('surveys');
  };

  return (
    <div className="container mx-auto py-8 px-4">
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Surveys & Feedback</h1>
        <p className="text-muted-foreground mt-2">
          Complete your assigned surveys and share feedback with mentors, instructors, and administrators.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="surveys" className="flex items-center gap-2">
            <ClipboardList className="h-4 w-4" />
            My Surveys
          </TabsTrigger>
          <TabsTrigger value="feedback" className="flex items-center gap-2">
            <MessageSquare className="h-4 w-4" />
            Feedback Center
          </TabsTrigger>
        </TabsList>

        <TabsContent value="surveys" className="space-y-6">
          <UserSurveyDashboard onTakeSurvey={handleTakeSurvey} />
        </TabsContent>

        <TabsContent value="feedback" className="space-y-6">
          <FeedbackCenter />
        </TabsContent>

        {/* Hidden tab for taking surveys */}
        <TabsContent value="take-survey" className="space-y-6">
          {currentSurvey && (
            <div className="space-y-4">
              <div className="flex items-center gap-2 text-muted-foreground">
                <FileText className="h-4 w-4" />
                <span>Taking Survey</span>
              </div>
              <SurveyTaker 
                surveyId={currentSurvey.id}
                onComplete={handleCompleteSurvey}
              />
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
}